import { lazy, Suspense } from "react"

import { MarvinAnimatedSvg, type MarvinAnimationProps } from "./MarvinAnimatedSvg"

// The artwork is 114 KiB of SVG text, and the not-found page that shows it can
// render anywhere, so it loads only when that page does.
const Marvin404Artwork = lazy(() =>
  import("./Marvin404Artwork").then((module) => ({ default: module.Marvin404Artwork })),
)

export function Marvin404Icon({ loop = true, ...props }: MarvinAnimationProps) {
  return (
    // The same svg box, empty, so the page keeps its layout while the artwork loads.
    <Suspense fallback={<MarvinAnimatedSvg {...props} loop={loop} source="" />}>
      <Marvin404Artwork {...props} loop={loop} />
    </Suspense>
  )
}
